import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Image from '@v4/components/common/Image'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EmbedVideo from '../../../../common/EmbedVideo'
import { useMedia } from './Media.hooks'

const Media = props => {
	const [{ classes, className, metaData, align, shading, objectFit, isBackground, autoplay, key }] = useMedia(props)

	return (
		<div className={clsx(classes.root, className, 'media')}>
			{metaData.isAssetVideo && (
				<EmbedVideo
					metaData={metaData}
					shading={shading}
					align={align}
					objectFit={objectFit}
					autoplay={autoplay}
				/>
			)}
			{metaData.isAssetImage && (
				<Image
					key={key}
					className={clsx(classes.image, 'question-image')}
					metaData={metaData}
					isBackground={isBackground}
				/>
			)}
		</div>
	)
}

Media.propTypes = {
	align: PropTypes.string,
	position: PropTypes.string,
	shading: PropTypes.number,
	className: PropTypes.string,
	objectFit: PropTypes.oneOf(['contain', 'cover']),
	isBackground: PropTypes.bool,
	metaData: PropTypes.instanceOf(PageMetaData),
	autoplay: PropTypes.bool,
}

export default memo(Media)
